import ReactPlayer from 'react-player'

interface VideoPlayerArgs {
    videoDocumentPath: string
}

const VideoPlayer = ({ videoDocumentPath }: VideoPlayerArgs) => {
    console.log("videoDocumentPath", videoDocumentPath);

    const videoUrl = `${window.location.origin}${videoDocumentPath.startsWith('/') ? videoDocumentPath : '/' + videoDocumentPath}`;

    return (
        <div>
            <ReactPlayer url={videoUrl} controls />
        </div>
    )
}

export default VideoPlayer